import { Container, Graphics, Rectangle, Text } from "pixi.js"
import { BUILDING_SHAPES, BuildingShape } from "../../../../building_shapes"
import { SCALER } from "../../../../client_util"

export class BuildingShapePalette extends Container {
    private background = new Graphics()
    private buttons = new Map<BuildingShape, Graphics>()
    private caption = new Text("", { fontFamily: "Arial", fontSize: 11, fill: 0xffd166 })
    private hint = new Text("Scroll or click · drag to draw", { fontFamily: "Arial", fontSize: 9, fill: 0xaeb8c5 })
    private signature = ""
    private locked = false

    constructor(onSelect: (shape: BuildingShape) => void) {
        super()
        this.visible = false
        this.zIndex = 60002
        this.scale.y = 1 / SCALER
        this.interactive = true
        this.hitArea = new Rectangle(0, 0, 164, 78)
        this.background.beginFill(0x000000, 0.2).drawRoundedRect(0, 3, 164, 78, 9).endFill()
        this.background.lineStyle(1, 0x657080, 0.8).beginFill(0x20262d, 0.96).drawRoundedRect(0, 0, 164, 78, 9).endFill()
        this.addChild(this.background)
        this.caption.position.set(10, 7)
        this.hint.position.set(10, 62)
        this.addChild(this.caption, this.hint)
        BUILDING_SHAPES.forEach((shape, index) => {
            const button = new Graphics()
            button.position.set(9 + index * 50, 25)
            button.hitArea = new Rectangle(0, 0, 46, 31)
            button.buttonMode = true
            button.on("pointerdown", event => {
                event.stopPropagation()
                if (!this.locked) onSelect(shape)
            })
            this.buttons.set(shape, button)
            this.addChild(button)
        })
    }

    setState = (visible: boolean, shape: BuildingShape, locked: boolean, hollow: boolean) => {
        this.visible = visible
        this.locked = locked
        const signature = `${shape}:${locked}:${hollow}`
        if (signature === this.signature) return
        this.signature = signature
        this.caption.text = `${shape[0].toUpperCase() + shape.slice(1)} · ${locked ? "drawing" : shape === "line" ? "stroke" : hollow ? "outline" : "filled"}`
        this.hint.text = locked ? "Release to start printing" : "Scroll or click · drag to draw"
        this.buttons.forEach((button, candidate) => {
            const selected = candidate === shape
            button.interactive = !locked
            button.clear().lineStyle(1, selected ? 0xffd166 : 0x48515e)
                .beginFill(selected ? 0x51452c : 0x2c333d).drawRoundedRect(0, 0, 46, 31, 5).endFill()
            button.lineStyle(1.5, selected ? 0xffd166 : 0xd0d8e2)
            if (!hollow && candidate !== "line") button.beginFill(selected ? 0xffd166 : 0xd0d8e2, 0.3)
            if (candidate === "rectangle") button.drawRect(13, 8, 20, 15)
            else if (candidate === "ellipse") button.drawEllipse(23, 15.5, 11, 8)
            else button.moveTo(13, 22).lineTo(33, 9)
            if (!hollow && candidate !== "line") button.endFill()
        })
    }
}
